import contactologiaReducer from './contactologiaReducer';

export default contactologiaReducer;